import React, { createContext, useMemo, useState } from "react";

import { useServiceWorker } from "config/useServiceWorker";

export type ServiceWorkerContextType = {
  isUpdateReady: boolean;
  updateServiceWorker: (redirectUrl?: string) => void;
};

export type ServiceWorkerProviderProps = {
  children: React.ReactNode;
};

export const ServiceWorkerContext = createContext<ServiceWorkerContextType | null>(null);

export function ServiceWorkerProvider({ children }: ServiceWorkerProviderProps) {
  const [isUpdateReady, setIsUpdateReady] = useState(false);

  const { update } = useServiceWorker({
    onUpdate: () => setIsUpdateReady(true),
  });

  // Memoize the context value
  const contextValue = useMemo(
    () => ({
      isUpdateReady,
      updateServiceWorker: update,
    }),
    [isUpdateReady, update]
  );

  return <ServiceWorkerContext.Provider value={contextValue}>{children}</ServiceWorkerContext.Provider>;
}
